import type { Recipe } from '@/types';
import { time } from '@/time';

const recipe: Recipe = {
  title: 'Pico de Gallo',
  source: 'https://www.seriouseats.com/classic-pico-de-gallo-salsa-fresca-recipe',
  totalTime: time(0, 40),
  servings: 16,
  tags: { type: 'sauce' },
  ingredients: [
    { name: 'tomatoes', quantity: '1 1/2', unit: 'lb',
      note: 'diced into 1/4–1/2 in pieces',
    },
    { name: 'salt', quantity: '1', unit: 'tsp',
      amountNote: 'plus more to taste',
    },
    { name: 'white onion', quantity: '1/2',
      note: 'finely diced',
    },
    { name: 'jalapeno', quantity: '2',
      note: 'finely diced',
    },
    { name: 'fresh cilantro', quantity: '1/2', unit: 'cup',
      note: 'finely chopped leaves',
    },
    { name: 'lime', quantity: '1', 
      note: 'juiced',
    },
  ],
  directions: [
    {
      title: 'Drain tomatoes',
      bullets: [
        "Season {tomatoes} with {salt} & toss to combine",
        "Transfer to strainer set in bowl",
        "Drain 20–30 min",
        "Discard liquid",
      ],
    },
    {
      title: 'Combine',
      bullets: [
        "In bowl, combine drained tomatoes with {white onion}, {jalapeno}, {fresh cilantro} & {lime}",
        "Toss to combine",
        "Season to taste with additional salt",
      ],
    },
  ],
};

export default recipe;
